/* tslint:disable */

declare var Object: any;
export interface ERPsalesOrderInterface {
  "id"?: number;
}

export class ERPsalesOrder implements ERPsalesOrderInterface {
  "id": number;
  constructor(data?: ERPsalesOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesOrder`.
   */
  public static getModelName() {
    return "ERPsalesOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesOrder for dynamic purposes.
  **/
  public static factory(data: ERPsalesOrderInterface): ERPsalesOrder{
    return new ERPsalesOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesOrder',
      plural: 'ERPsalesOrders',
      path: 'ERPsalesOrders',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesOrder.ts